import { parse } from 'next-useragent';

import { ArtworkFormatId } from '@/common/types/Artwork/Artwork.type';
import { isRetinaDevice } from '@/common/utils/sharedUtils';

export const getItemVariant = (
  itemId: number,
  formatId: ArtworkFormatId,
  finishId: number | string,
  frameId: number | string,
) => {
  return `${itemId}-${formatId}-${finishId}-${frameId}`;
};

export const getBrandsCreativeNameForTracking = (urlAbsolutePath: string): string => {
  return urlAbsolutePath
    .split('/')
    .slice(-2)
    .filter((el) => el)
    .join('/');
};

export type GTMImageDescription =
  | 'mobileRetina'
  | 'mobileStandard'
  | 'desktopRetina'
  | 'desktopStandard'
  | 'undefined';
export const getGTMImageDescription = (): GTMImageDescription => {
  if (typeof window === 'undefined') return 'undefined';
  const deviceType = parse(window.navigator.userAgent).isMobile ? 'mobile' : 'desktop';
  const isRetina = isRetinaDevice() ? 'Retina' : 'Standard';
  return `${deviceType}${isRetina}`;
};

export const getImageNameFromUrl = (url: string): string => {
  return url.split('/').pop() || url;
};

export const getVideoIdFromUrl = (url: string): string => {
  return url.match(/https:\/\/player\.vimeo\.com\/external\/(\d+)\.m3u8/)?.[1] || '';
};
